import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../types/types';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { IColor } from '../../../../../../../../types/model';
import { onEdit } from '../../../../../../aside_panel/cardDetails/ColorTags/hocs/events/onEdit';
import { SegmentCardType } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { ISegmentEventOption } from '../../../../../../../../middlewares/segment/trackEntities/types';

export const onEditColor = (
    boardId: TBoardId,
    colorTag: IColor,
    source: SegmentCardType,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const option: ISegmentEventOption = source && {
            name: SegmentCardOptions.TYPE,
            value: SegmentCardType.CARD_INPUT
        };
        dispatch(onEdit(boardId, colorTag));
        dispatch(segmentTrackAction(SegmentCardEvent.COLOUR_TAGS_DOUBLE_CLICK_SAVE, option));
    };
    return action;
};
